const GIF_QUALITY = "gifQuality";

const GIF_SOUND = "gifSound";

const TEMPORARY_ACCESS_TOKEN = "temporary_access_token";

const DISABLE_ADS = "disable_ads";

const AUTH_DATA = "auth_data";

const LS_KEY = "cookie_notice";

const EXPERIMENTS = "experiments";

const BOOSTED_GIFS = "boosted_gifs";

const DISMISS_SCROLL_MORE = "dismiss_scroll_more";

const ANONYMOUS_LIKED_TOAST = "anonymous_liked_toast";

const TOTAL_PLAYBACK_TIME = "total_playback_time";

const WATCHED_120S = "watched_120s";

const load = (key: string, storage: Storage | null) => () => {
  if (!storage) {
    return null;
  }

  const serializedValue = storage.getItem(key);

  if (serializedValue === null) {
    return serializedValue;
  }

  try {
    return JSON.parse(serializedValue);
  } catch (e) {
    return serializedValue;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const set = (key: string, storage: Storage | null) => (value?: any) => {
  if (!storage) {
    return;
  }

  if (typeof value !== "undefined" && value !== null) {
    const serializedValue = ["object", "array"].includes(typeof value)
      ? JSON.stringify(value)
      : value;

    storage.setItem(key, serializedValue);
  } else {
    remove(key, storage)();
  }
};

const remove = (key: string, storage: Storage) => () => {
  storage.removeItem(key);
};

const getLocalStorage = () => {
  try {
    return localStorage;
  } catch (e) {
    const { name, message } = e as Error;
    // eslint-disable-next-line
    console.log(name, message);
  }

  return null;
};

const getSessionStorage = () => {
  try {
    return sessionStorage;
  } catch (e) {
    const { name, message } = e as Error;
    // eslint-disable-next-line
    console.log(name, message);
  }

  return null;
};

export const loadTemporaryAccessToken = load(TEMPORARY_ACCESS_TOKEN, getLocalStorage());

export const loadDisableAds = load(DISABLE_ADS, getLocalStorage());

export const loadAuth = load(AUTH_DATA, getLocalStorage());

export const loadGIFQuality = load(GIF_QUALITY, getLocalStorage());

export const loadGIFSound = load(GIF_SOUND, getLocalStorage());

export const loadCookieNotice = load(LS_KEY, getLocalStorage());

export const loadExperiments = load(EXPERIMENTS, getLocalStorage());

export const loadBoostedGifs = load(BOOSTED_GIFS, getLocalStorage());

export const loadDismissScrollMore = load(DISMISS_SCROLL_MORE, getLocalStorage());

export const loadAnonymousLikedToast = load(ANONYMOUS_LIKED_TOAST, getLocalStorage());

export const loadTotalPlaybackTime = load(TOTAL_PLAYBACK_TIME, getSessionStorage());

export const loadWatched120s = load(WATCHED_120S, getSessionStorage());

export const setGIFSound = (value: string) => set(GIF_SOUND, getLocalStorage())(value);

export const setGIFQuality = (value: string) => set(GIF_QUALITY, getLocalStorage())(value);

export const setCookieNotice = (value: string) => set(LS_KEY, getLocalStorage())(value);

export const setTemporaryAccessToken = set(TEMPORARY_ACCESS_TOKEN, getLocalStorage());

export const setAuth = set(AUTH_DATA, getLocalStorage());

export const setExperiments = set(EXPERIMENTS, getLocalStorage());

export const setBoostedGifs = set(BOOSTED_GIFS, getLocalStorage());

export const setDismissScrollMore = set(DISMISS_SCROLL_MORE, getLocalStorage());

export const setAnonymousLikedToast = set(ANONYMOUS_LIKED_TOAST, getLocalStorage());

export const setTotalPlaybackTime = set(TOTAL_PLAYBACK_TIME, getSessionStorage());

export const setWatched120s = set(WATCHED_120S, getSessionStorage());
